import { connect } from 'react-redux';
import { getIsMobile } from 'src/store/view/selectors';
import { getHotelName, getHotelStars } from 'src/routes/Hotel/store/hotel';
import { getHotelExperiences } from '../../store/selectors/experiences';
import { MENU_ITEMS_ID } from '../../constants';
import { scrollToSectionAction } from '../../store/actions/view';
import ExperienceContainer from './ExperienceContainer';

const mapStateToProps = (state) => ({
  experiences: getHotelExperiences(state),
  hotelName: getHotelName(state),
  hotelStars: getHotelStars(state),
  isMobile: getIsMobile(state),
});

const mapDispatchToProps = (dispatch) => ({
  scrollToSectionTop: () =>
    dispatch(scrollToSectionAction(MENU_ITEMS_ID.EXPERIENCE)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ExperienceContainer);
